<!--
 * @Author: Gaho
 * @Date: 2024-02-28 18:24:09
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-19 10:22:34
 * @Description: 
-->
<template>
    <div class="mb-[5px] cofficient-wrap">
        <div class="cofficient-desktop gap-1 flex">
            <div
                :class="['cofficientItem', level - 1 === k ? 'bg-[#297fe5] text-white' : 'bg-[#1b2233]']"
                class="cofficientItem flex-1"
                v-for="(v, k) in stoneOptions[stoneNum]"
                :key="k"
            >
                {{ formatMulti(v) }}
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { roundData } from '../data/index';

const props = defineProps({
    stoneNum: {
        type: Number,
        required: true,
    },
    level: {
        type: Number,
        required: true,
    },
    round: {
        type: Object as PropType<typeof roundData>,
        required: true,
    },
    stoneOptions: {
        type: Object,
        required: true,
    },
});

/**
 * 格式化倍率
 * 长度>=4则精确到整数
 * 否则保留两位小数
 * @param multi 倍率
 */
const formatMulti = (multi: Number) => {
    const multiArr = String(multi).split('.');
    if (multiArr[0].length >= 4) {
        // 抹掉小数
        return `x${multiArr[0]}`;
    } else {
        return `x${getFixed(multi)}`;
    }
}
</script>

<style lang="scss" scoped>
.cofficientItem {
    border-radius: 7px;
    box-sizing: border-box;
    color: #55657e;
    font-size: 12px;
    font-weight: 700;
    padding: 5px 4px;
    text-align: center;
    transition: all 0.3s;
    min-width: 65px;
}
.cofficient-desktop {
    flex-direction: column-reverse;
    padding-right: 5px;
}
</style>
